<template>
  <section class="cx-div">
    <h4 class="-border-bottom">{{ option.name }}</h4>
    <div class="cx-t02 cx-checkbox" v-if="hasCarPark" @click="pref.carPark = pref.carPark === null ? 1 : null">
      <input type="checkbox" id="" class="cx-checkbox__input" :checked="pref.carPark === 1">
      <label for="" class="cx-checkbox__label">{{ settings.filter.carPark }}</label>
    </div>
    <div class="cx-t02 cx-checkbox" v-if="hasValetParking" @click="pref.valetParking = pref.valetParking === null ? 1 : null">
      <input type="checkbox" id="" class="cx-checkbox__input" :checked="pref.valetParking === 1">
      <label for="" class="cx-checkbox__label">{{ settings.filter.valetParking }}</label>
    </div>
    <div class="cx-t02 cx-checkbox" v-if="hasVisuallyImpaired" @click="pref.visuallyImpaired = pref.visuallyImpaired === null ? 1 : null">
      <input type="checkbox" id="" class="cx-checkbox__input" :checked="pref.visuallyImpaired === 1">
      <label for="" class="cx-checkbox__label">{{ settings.filter.visuallyImpaired }}</label>
    </div>
    <div class="cx-t02 cx-checkbox" v-if="hasHearingImpaired" @click="pref.hearingImpaired = pref.hearingImpaired === null ? 1 : null">
      <input type="checkbox" id="" class="cx-checkbox__input" :checked="pref.hearingImpaired === 1">
      <label for="" class="cx-checkbox__label">{{ settings.filter.hearingImpaired }}</label>
    </div>
    <div class="cx-t02 cx-checkbox" v-if="hasLocked" @click="pref.locked = pref.locked === null ? 1 : null">
      <input type="checkbox" id="" class="cx-checkbox__input" :checked="pref.locked === 1">
      <label for="" class="cx-checkbox__label">{{ settings.filter.locked }}</label>
    </div>
    <div v-if="wheelChairOptions.length > 0"
      @click="toggle"
      @mouseenter="showDropdown"
      @mouseleave="hideDropdown"
      class="cx-t02 cx-dropdown"
    >
      <span>{{ $t('accessibility.wheelChairUser') || 'accessibility.wheelChairUser' }}</span>
      <span class="cx-dropdown__trigger">
        <a class="cx-link">
          {{ selectedWheelChairText }} <i class="fal fa-angle-down"></i>
        </a>
      </span>
      <template v-if="show">
        <div class="cx-dropdown__content">
          <ul class="cx-list--vertical">
            <li v-for="(option, index) in wheelChairOptions" :key="index" class="cx-list__item">
              <a @click.prevent="selectWheelChair(option)" class="cx-link">{{ wheelChairOptionText(option) }}</a>
            </li>
          </ul>
        </div>
      </template>
    </div>
  </section>
</template>

<script>
export default {
  name: 'accessibility-filter-option',
  props: {
    option: Object,
    settings: Object,
  },
  data() {
    return {
      show: false,
      wheelChairConvertor: [null, 1, 2],
      pref: {
        carPark: null,
        locked: null,
        valetParking: null,
        visuallyImpaired: null,
        hearingImpaired: null,
        wheelChair: null,
      },
    };
  },
  watch: {
    pref: {
      deep: true,
      handler() {
        this.$emit('pref-changed', this.option.name, this.pref);
      },
    },
  },
  computed: {
    hasCarPark() {
      return this.option.options.carPark !== undefined;
    },
    hasVisuallyImpaired() {
      return this.option.options.visuallyImpaired !== undefined;
    },
    hasHearingImpaired() {
      return this.option.options.hearingImpaired !== undefined;
    },
    hasLocked() {
      return this.option.options.locked !== undefined;
    },
    hasValetParking() {
      return this.option.options.valetParking !== undefined;
    },
    wheelChairOptions() {
      const temp = this.option.options.wheelChair
        .filter(item => item !== 0)
        .sort((a, b) => {
          return a - b;
        });
      if (temp && temp.length > 0) {
        temp.unshift(null);
      }

      return temp;
    },
    selectedWheelChairText() {
      return this.settings.filter.wheelChair[this.pref.wheelChair === null ? 0 : this.pref.wheelChair];
    },
  },
  methods: {
    toggle() {
      this.show = !this.show;
    },
    showDropdown() {
      this.show = true;
    },
    hideDropdown() {
      this.show = false;
    },
    selectWheelChair(option) {
      this.pref.wheelChair = option;
    },
    wheelChairOptionText(option) {
      return this.settings.filter.wheelChair[option === null ? 0 : option];
    },
    clear() {
      this.pref = {
        carPark: null,
        locked: null,
        valetParking: null,
        visuallyImpaired: null,
        hearingImpaired: null,
        wheelChair: null,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.cx-dropdown__content {
  margin-top: 0;
}
</style>
